export const LOADING_AGENCY_PROPERTIES = 'agencyProperties/LOAD_AGENCY_PROPERTIES'
export const LOADING_AGENCY_PROPERTIES_SUCCESS = 'agencyProperties/LOAD_AGENCY_PROPERTIES_SUCCESS'
export const LOADING_AGENCY_PROPERTIES_FAILURE = 'agencyProperties/LOAD_AGENCY_PROPERTIES_FAILURE'
